import { VooiAbstractTrade } from '../../common/vooi-abstract/vooi-abstract-trade';

export class VooiLineaTrade extends VooiAbstractTrade {
    public readonly dexContractAddress = '0xBc7f67fA9C72f9fcCf917cBCEe2a50dEb031462A';
}
